import { render, staticRenderFns } from "./ClientsDebtContainer.vue?vue&type=template&id=452bbf5e"
import script from "./ClientsDebtContainer.ts?vue&type=script&lang=ts&external"
export * from "./ClientsDebtContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports